import { makeAutoObservable } from "mobx";
import { formatAddress, } from ".";
import { ApartmentInfo, ApartmentInfoStorageManager, FULFILLMENT_METHOD_STORAGE_KEY, Money, ONLINE_CONTACT_DETAILS_KEY, UserNote, } from "..";
import { FulfillmentMethodTypeStorageManager } from "../storageManagers/FulfillmentMethodTypeStorageManager";
// TODO: consider to create separate class for QrWaiter
export class POrderDetails {
    constructor(params) {
        this.restaurant = params.restaurant;
        this.country = params.country;
        this.fulfillmentTime = params.fulfillmentTime;
        this.fulfillmentInstructions = params.fulfillmentInstructions;
        this.promotionScheme = params.promotionScheme;
        makeAutoObservable(this);
    }
    initialize() {
        this.promotionScheme.initialize();
        if (this.fulfillmentInstructions.type === "Online") {
            this.fulfillmentInstructions.deliveryAddress.initialize();
        }
    }
    dispose() {
        this.promotionScheme.dispose();
        if (this.fulfillmentInstructions.type === "Online") {
            this.fulfillmentInstructions.deliveryAddress.dispose();
        }
    }
    get promotionInstances() {
        return this.promotionScheme.promotionInstances;
    }
    clearCoupon() {
        this.promotionScheme.clearCoupon();
    }
    get couponState() {
        return this.promotionScheme.couponState;
    }
    get isDelivery() {
        if (this.fulfillmentInstructions.type === "QrWaiter") {
            return false;
        }
        return this.fulfillmentInstructions.isDelivery;
    }
    get isPostCodeRequired() {
        if (this.fulfillmentInstructions.type === "QrWaiter") {
            return false;
        }
        return this.fulfillmentInstructions.deliveryAddress.streetAddress
            .isPostCodeRequired;
    }
    get userNoteMaxLength() {
        return UserNote.MAX_LENGTH;
    }
    get deliveryAddressStatus() {
        if (this.fulfillmentInstructions.type === "QrWaiter") {
            return { type: "NotRequested" };
        }
        return this.fulfillmentInstructions.deliveryAddress.status;
    }
    get minOrderValue() {
        if (this.isDelivery &&
            this.deliveryAddressStatus.type === "RestaurantDelivers") {
            return this.deliveryAddressStatus.minOrderValue;
        }
        return Money.zero();
    }
    get fulfillmentMethodType() {
        return this.fulfillmentInstructions.fulfillmentMethodType;
    }
    get fulfillmentMethodAddress() {
        if (this.fulfillmentInstructions.fulfillmentMethodType === null) {
            return null;
        }
        switch (this.fulfillmentInstructions.fulfillmentMethodType) {
            case "Delivery":
            case "NoContactDelivery": {
                const { streetAddress } = this.fulfillmentInstructions.deliveryAddress;
                return formatAddress(streetAddress, streetAddress.isPostCodeRequired);
            }
            case "DineIn":
            case "Takeaway":
                return this.restaurantAddress;
        }
    }
    get restaurantAddress() {
        const address = {
            street: this.restaurant.address.street !== null
                ? this.restaurant.address.street
                : "",
            streetNumber: "",
            city: this.restaurant.address.city,
            postCode: this.restaurant.address.postCode,
        };
        return formatAddress(address, true);
    }
    get doesAnyPromotionRequireMarketingConsents() {
        return this.promotionScheme.doesAnyPromotionRequireMarketingConsents;
    }
    disableMarketingPromotionInstances() {
        this.promotionScheme.disableMarketingPromotionInstances();
    }
    get isStoredFulfillmentMethodCart() {
        return localStorage.getItem(FULFILLMENT_METHOD_STORAGE_KEY) !== null;
    }
    get isStoredFulfillmentMethodCheckout() {
        var _a, _b;
        const apartmentInfo = new ApartmentInfoStorageManager({
            country: this.country,
        }).restore();
        const fulfillmentMethod = new FulfillmentMethodTypeStorageManager((_b = (_a = this.restaurant.domain.fulfillmentMethods) === null || _a === void 0 ? void 0 : _a.raw) !== null && _b !== void 0 ? _b : []).restore();
        if (fulfillmentMethod === "Takeaway" || fulfillmentMethod === "DineIn") {
            return true;
        }
        else {
            return (fulfillmentMethod !== null &&
                apartmentInfo !== null &&
                !ApartmentInfo.fromStorageData({
                    country: this.country,
                    storageData: apartmentInfo,
                }).isEmpty);
        }
    }
    // TODO: check that stored value is available / valid
    get isStoredContact() {
        return localStorage.getItem(ONLINE_CONTACT_DETAILS_KEY) !== null;
    }
}
